/**
 * 자료실: 첨부 2개 이상일 때 다운로드 드롭다운 (이벤트 위임, 문서당 1회 바인딩)
 */
export class ResourcesDownloads {
    constructor() {
        this.root = document.querySelector(".no-resources");
        if (!this.root) {
            return;
        }
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.bind();
    }

    bind() {
        this.root.addEventListener("click", (e) => {
            const card = e.target.closest("[data-resource-link]");
            if (!card || !this.root.contains(card)) {
                return;
            }

            // 버튼/링크/입력 요소 클릭은 본래 동작 유지
            const interactive = e.target.closest(
                "a, button, input, textarea, select, [data-resources-dropdown]",
            );
            if (interactive) {
                return;
            }

            const href = card.getAttribute("data-resource-link");
            if (href) {
                window.location.href = href;
            }
        });

        this.root.addEventListener("keydown", (e) => {
            const card = e.target.closest("[data-resource-link]");
            if (!card || !this.root.contains(card)) {
                return;
            }
            if (e.key !== "Enter" && e.key !== " ") {
                return;
            }
            e.preventDefault();
            const href = card.getAttribute("data-resource-link");
            if (href) {
                window.location.href = href;
            }
        });

        this.root.addEventListener("click", (e) => {
            const toggle = e.target.closest("[data-resources-toggle]");
            if (!toggle || !this.root.contains(toggle)) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const wrap = toggle.closest("[data-resources-dropdown]");
            if (!wrap) {
                return;
            }
            const willOpen = !wrap.classList.contains("is-open");
            this.closeAll();
            if (willOpen) {
                wrap.classList.add("is-open");
                toggle.setAttribute("aria-expanded", "true");
                document.addEventListener("click", this.onDocumentClick, true);
                document.addEventListener("keydown", this.onDocumentKeydown, true);
            }
        });
    }

    onDocumentClick(e) {
        if (e.target.closest("[data-resources-dropdown]")) {
            return;
        }
        this.closeAll();
    }

    onDocumentKeydown(e) {
        if (e.key === "Escape") {
            this.closeAll();
        }
    }

    closeAll() {
        this.root
            .querySelectorAll("[data-resources-dropdown].is-open")
            .forEach((el) => {
                el.classList.remove("is-open");
                const btn = el.querySelector("[data-resources-toggle]");
                if (btn) {
                    btn.setAttribute("aria-expanded", "false");
                }
            });
        document.removeEventListener("click", this.onDocumentClick, true);
        document.removeEventListener("keydown", this.onDocumentKeydown, true);
    }
}
